
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconsInfoPressed2X = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 36,
  height: 36,
  viewBox: "0 0 24 24",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm0 3.538a1.358 1.358 0 1 1-1.358 1.358A1.364 1.364 0 0 1 12 7.538Zm1.421 8.586a.389.389 0 0 0 .39-.388l-.007-.76a.389.389 0 0 0-.389-.388h-.389v-3.225a.389.389 0 0 0-.389-.39h-2.059a.389.389 0 0 0-.388.39v.764c0 .215.174.39.389.39h.388v2.065h-.389a.389.389 0 0 0-.388.388v.765c0 .215.174.39.389.39h2.842Z",
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"36\" height=\"36\" viewBox=\"0 0 24 24\" fill=\"none\">\r\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4ZM12 7.53785C12.7499 7.53785 13.3578 8.14574 13.3578 8.89562C13.3578 9.64549 12.7499 10.2534 12 10.2534C11.2501 10.2534 10.6422 9.64549 10.6422 8.89562C10.6457 8.14719 11.2516 7.54134 12 7.53785ZM13.4215 16.1243C13.6363 16.1243 13.8104 15.9502 13.8104 15.7355L13.804 14.9769C13.804 14.7621 13.6299 14.588 13.4151 14.588H13.0263V11.3625C13.0263 11.1478 12.8522 10.9737 12.6375 10.9737H10.5785C10.3637 10.9737 10.1896 11.1478 10.1896 11.3625V12.1275C10.1896 12.3422 10.3637 12.5163 10.5785 12.5163H10.9673V14.5817H10.5785C10.3637 14.5817 10.1896 14.7558 10.1896 14.9705V15.7355C10.1896 15.9502 10.3637 16.1243 10.5785 16.1243H13.4215Z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/icons-info-pressed@2x.65f145a02488500976a2d47ac906d405.svg"),
        {
          React: SvgIconsInfoPressed2X,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      